<div
	class="dropdown-container d-flex flex-wrap align-items-center justify-content-center"
	[bg-image]="'add-to-compare.png'"
	[bg-image-hover]="'add-to-compare-hover.png'"
	(click)="isCompareDropdownVisible = !isCompareDropdownVisible"
	(click-outside)="isCompareDropdownVisible = false"
>
	<div class="compare-border-box" [ngClass]="{ active: isCompareDropdownVisible }"></div>
	<ul class="compare-dropdown text-16" tabIndex="1" [ngClass]="{ hidden: !isCompareDropdownVisible }">
		<li class="li-header" dcrHTMLKey="RECENTLY_USED_MODELS_LABEL">Recently used</li>
		<li *ngFor="let selectedFamily of selectedModels" [value]="family" [disabled]="selectedFamily?.disabled" (click)="addToCompare(selectedFamily)">
			{{ selectedFamily.familyName }}
		</li>

		<li class="li-header" dcrHTMLKey="ALL_MODELS_LABEL">All Models</li>
		<li *ngFor="let family of familyList" [value]="family" [disabled]="family?.disabled" (click)="addToCompare(family)">
			{{ family.familyName }}
		</li>
	</ul>
</div>
